import React from 'react';
import styled from 'styled-components';
import { baseCardCSS } from '../../theme';

// --- STYLES DEFINED LOCALLY ---
const CardContainer = styled.div`
  ${baseCardCSS}
  cursor: pointer;
`;

const CardHeader = styled.h3`
  color: ${({ theme }) => theme.heading};
  margin-top: 0;
  margin-bottom: 20px;
  font-size: 18px;
`;

const StatRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  margin-bottom: 8px;
`;

const StatLabel = styled.span`
  color: ${({ theme }) => theme.text};
`;

const StatValue = styled.span`
  color: ${({ theme }) => theme.heading};
  font-weight: 600;
  background-color: ${({ theme }) => theme.navActiveBg};
  padding: 2px 8px;
  border-radius: 6px;
`;


// --- COMPONENT LOGIC ---
const DateCard = ({ monthYear, stats, onClick }) => {
  return (
    <CardContainer onClick={onClick}>
      <CardHeader>{monthYear}</CardHeader>
      <StatRow>
        <StatLabel>Pending</StatLabel>
        <StatValue>{stats.pending}</StatValue>
      </StatRow>
      <StatRow>
        <StatLabel>Total Documents</StatLabel>
        <StatValue>{stats.total}</StatValue>
      </StatRow>
    </CardContainer>
  );
};

export default DateCard;